import { render } from "./CarouselSlide.vue?vue&type=template&id=37171f21"
import script from "./CarouselSlide.vue?vue&type=script&lang=js"
export * from "./CarouselSlide.vue?vue&type=script&lang=js"

import "./CarouselSlide.vue?vue&type=style&index=0&id=37171f21&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__